import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { selectClientId } from '../../../store/selectors/client'
import { selectHomeId } from '../../../store/selectors/home'
import { PATH_HELPERS } from '../../../constants/navigation'
import { selectActiveNavigationTab } from '../../../store/slices/navigation'
import { NAVIGATION_TAB_NAMES } from '../../../types/navigation'

const RedirectToHomeDigest = () => {
  const clientId = useSelector(selectClientId)
  const homeId = useSelector(selectHomeId)
  const tabName = useSelector(selectActiveNavigationTab)

  if (!clientId) {
    return <Redirect to='/not-found' />
  }

  switch (tabName) {
    case NAVIGATION_TAB_NAMES.HOMES:
      return <Redirect to={PATH_HELPERS.home.buildPath(clientId, homeId)} />

    case NAVIGATION_TAB_NAMES.BUYER:
      return <Redirect to={PATH_HELPERS.buy.buildPath(clientId)} />

    case NAVIGATION_TAB_NAMES.MARKET:
      return <Redirect to={PATH_HELPERS.markets.buildPath(clientId)} />

    default:
      return null
  }
}

export default RedirectToHomeDigest
